import FieldReadOnly from "../../read-only-value/read-only"
import FieldConfig from "../../../proto/field-config"
import {FieldFilterType} from "../../../proto/types"
import {GROUP_DATE_TIME} from "../../../../gd/const/fields/field2-groups"
import Format from "../../../../gd/utils/format"
import DatetimeUtils from "../../../../gd/utils/datetime-utils"
import {
    ConditionType_DateFixedAfter,
    ConditionType_DateFixedBefore,
    ConditionType_DateFixedEquals,
    ConditionType_DateFixedRange,
    ConditionType_DateRelativeAfter,
    ConditionType_DateRelativeBefore,
    ConditionType_DateRelativeEquals,
    ConditionType_DateRelativePeriod,
    ConditionType_DateRelativeRange
} from "../../../../model2/conditions/condition-types"
import FieldMoment_ConditionForm from "./render/condition"

/*

CAREFULL - I use it only in time report and expense to display moment created... it is supposed to be READ ONLY
us DATETIME field (or creat) when need date + time editable (!)

 */

export default class FieldMoment extends FieldReadOnly {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Moment";
        this.filterType         = FieldFilterType.DATE;
        this.typeGroup          = GROUP_DATE_TIME;
        this.typeDescription    = "Moment read only";
        this.icon               = 'i5-calendar';

        this.conditionTypes = [
            ConditionType_DateRelativeBefore,
            ConditionType_DateRelativeAfter,
            ConditionType_DateRelativeEquals,
            ConditionType_DateRelativeRange,
            ConditionType_DateRelativePeriod,

            ConditionType_DateFixedBefore,
            ConditionType_DateFixedAfter,
            ConditionType_DateFixedEquals,
            ConditionType_DateFixedRange,
        ]

        this.renderComponents.conditionForm = FieldMoment_ConditionForm

        // this.renderComponents.glistView = this.renderComponents.viewSmall

        // this.renderComponents.viewSmall     =
    }

    getDisplayValue(value: Moment): string {
        if (!value) return value
        return Format.datetimeUserFormat(value)
    }

    sortValue(value:any) {
        return value ? DatetimeUtils.datetimeToMoment(value).format('x') : 0;
    }

    normalizeToCSVValue(model:any): any {
        const rawValue = super.normalizeToCSVValue(model)
        const res: string | null = !_.isEmpty(rawValue) ? DatetimeUtils.momentToUTCISODatetime(moment(rawValue)) : null
        return !!res ? res : ''
    }
}
